import { render, staticRenderFns } from "./TheSendEgiftPanel.vue?vue&type=template&id=b396b718&scoped=true"
import script from "./TheSendEgiftPanel.vue?vue&type=script&lang=js"
export * from "./TheSendEgiftPanel.vue?vue&type=script&lang=js"
import style0 from "./TheSendEgiftPanel.vue?vue&type=style&index=0&id=b396b718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b396b718",
  null
  
)

export default component.exports